var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEvent = function SvgEvent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.5C8.27614 1.5 8.5 1.72386 8.5 2V3.5H15.5V2C15.5 1.72386 15.7239 1.5 16 1.5C16.2761 1.5 16.5 1.72386 16.5 2V3.5H19C20.3807 3.5 21.5 4.61929 21.5 6V10V20C21.5 21.3807 20.3807 22.5 19 22.5H5C3.61929 22.5 2.5 21.3807 2.5 20V10V6C2.5 4.61929 3.61929 3.5 5 3.5H7.5V2C7.5 1.72386 7.72386 1.5 8 1.5ZM7.5 4.5H5C4.17157 4.5 3.5 5.17157 3.5 6V9.5H20.5V6C20.5 5.17157 19.8284 4.5 19 4.5H16.5V6C16.5 6.27614 16.2761 6.5 16 6.5C15.7239 6.5 15.5 6.27614 15.5 6V4.5H8.5V6C8.5 6.27614 8.27614 6.5 8 6.5C7.72386 6.5 7.5 6.27614 7.5 6V4.5ZM20.5 10.5H3.5V20C3.5 20.8284 4.17157 21.5 5 21.5H19C19.8284 21.5 20.5 20.8284 20.5 20V10.5Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.6666V18.3333M9.66663 16H14.3333",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEvent;